module.exports = __webpack_public_path__ + "static/media/Drive.93550aa9.svg";